import { Directive, ElementRef, Input, OnInit, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { AppScreenService } from 'src/app/service/screens.service';

@Directive({
    selector: '[appScreenAccess]',
})
export class ScreenAccessDirective implements OnInit {
    label: string = '';
    action: 'enabled' | 'view' | 'add' | 'edit' | 'delete' = 'view';
    @Input() set appScreenAccess(screen: any) {
        this.label = screen.label;
        this.action = screen.action;
    }

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private screenService: AppScreenService,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) { }

    ngOnInit(): void {
        this.screenService.screensLoaded$.pipe(
            filter(loaded => loaded),
            take(1)
        ).subscribe(() => {
            //setTimeout(() => {

            const screen = this.screenService.findScreen(this.label);

            if (screen) {
                // Check if the action is enabled for the screen
                if (screen?.hasOwnProperty(this.action) && !screen[this.action]) {
                    // If action is not allowed, disable the element or hide it
                    //this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
                    this.viewContainer.clear();
                }
                // Check if the action is allowed for the screen
                else if (screen?.actions?.hasOwnProperty(this.action) && !screen.actions[this.action]) {
                    // If action is not allowed, disable the element or hide it
                    //this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
                    this.viewContainer.clear();
                } else {
                    this.viewContainer.createEmbeddedView(this.templateRef)
                }
            } else {
                console.warn(`Screen with label "${this.label}" not found.`);
            }
            // });
        });
    }
}
